import React, { useCallback } from 'react'
import useParty from './useParty'
import { userColumnsHeaders, contactColumnsHeaders } from './columnsHeaders'
import GenericGrid from '../../../sharedcomponents/5templates/commonGrid/GenericGrid'
import GridWrapper from '../../../sharedcomponents/5templates/commonGrid/GridWrapper'
import useGridWrapper from '../../../sharedcomponents/5templates/commonGrid/useGridWrapper'
import {formatDateValue} from '../../../sharedcomponents/1elements/Fields/FormikDatePicker'
import { pageVars } from '../../../pages/const/pageVars'

const pageSettingsPeople = (() => {
  const {codeText, headerText, showWarning } = pageVars.PEOPLE
  return {
    showWarning: showWarning || false,
    codeText: codeText || 'pageCodeText',
    headerText: headerText || 'pageHeaderText',
  }
})()

const pageSettingsUser = (() => {
  const {codeText, headerText, showWarning } = pageVars.USERS
  return {
    showWarning: showWarning || false,
    codeText: codeText || 'pageCodeText',
    headerText: headerText || 'pageHeaderText',
  }
})()

const contactColumnsData  = (rowData, jobTitles, types) => ({
  id: rowData.id, //please note, the underlying datagrid assumes the id column is always called id
  name: [rowData.first_name, rowData.last_name].filter(seg => seg).join(' ') || 'No name',
  job_title: rowData.job_title_id
    ? (jobTitles.find(jt => jt.id === rowData.job_title_id)?.name || '')
    : '-',
  type: rowData.type_id
    ? (types.find(t => t.id === rowData.type_id)?.name || '')
    : '-',
  email: rowData['email']  || '-',
  phone: rowData['phone']  || '-',
  total_contracts: rowData.stats?.find(r => r.type === 'contracts')?.count,
  total_skillsets: rowData.stats?.find(r => r.type === 'skillsets')?.count,
  total_assets: rowData.stats?.find(r => r.type === 'assets')?.count
})

const userColumnsData  = (rowData) => ({
  id: rowData.id, //please note, the underlying datagrid assumes the id column is always called id
  name: [rowData.first_name, rowData.last_name].filter(seg => seg).join(' ') || 'No name',
  last_signin: (rowData?.last_signin && formatDateValue(rowData?.last_signin, 'toYYYY-MM-DD')) || 'Never',
  total_groups: rowData.stats?.find(r => r.type === 'groups.user')?.count,
  total_contracts: rowData.stats?.find(r => r.type === 'contracts')?.count,
  total_skillsets: rowData.stats?.find(r => r.type === 'skillsets')?.count,
  total_assets: rowData.stats?.find(r => r.type === 'assets')?.count,
  active: rowData.suspended_at ? false : true
})


const UserSummary = ({ type }) => {

  const defaultFetchParameter = {
    sort: '+last_name',
    page: 0,
    per_page: 20,
    include: ['stats']
  }

  const {
    loadParties,
    loadUsers,
    bulkUpdateParties,
    bulkUpdateUsersFromGrid,
    typeIdToDisplayName,
    listPartyTypes,
    listJobTitles,
  } = useParty()

  const {
    editMode,
    setEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    deletionChanges,
    deleteCallBack,
    activationChanges,
    activationCallBack,
    detailCallBack,
    addCallBack,
    handSaveCallback,
    isGridDirty
  } = useGridWrapper(
    type === 'user' ? pageSettingsUser.codeText : pageSettingsPeople.codeText,
    type === 'user' ? bulkUpdateUsersFromGrid : bulkUpdateParties
  )

  const openAddEntityPage = useCallback(
    (type, subType) => addCallBack(type, subType),
    [addCallBack],
  );

  // The Columns Headers
  const visibleColumns = type==='user' ? userColumnsHeaders : contactColumnsHeaders

  const fetchCallBack = async arg => {
    const lookups = []

    if (type === 'user') {
      lookups.push(
        loadUsers(arg),
        Promise.resolve([]),
        Promise.resolve([])
      )
    } else {
      lookups.push(
        loadParties({...arg, contact_only: true}),
        listJobTitles(),
        listPartyTypes()
      )
    }

    const [partyUsersResp, jobTitles, types] = await Promise.all(lookups)

    const isError = partyUsersResp.isError
    const data = partyUsersResp.data?.data || []

    // transform the server-provided array for display
    const rows = []
    data.forEach(one => {
      rows.push(
        type === 'user' ?
          userColumnsData(one) :
          contactColumnsData(one, jobTitles, types)
        )
    })

    return {
      newRows: rows,
      newPagination: partyUsersResp.data?.pagination ?? {},
      newSort: partyUsersResp.data?.sort ?? {},
      newLoading: false,
      newError: isError
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <GridWrapper
          header={type === 'user' ? 'Users' : 'People'}
          containedEntityType={type}
          editMode={editMode}
          setEditMode={setEditMode}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          isGridDirty={isGridDirty}
          addCallBack={openAddEntityPage}
          typeToTypeDisplayName={typeIdToDisplayName}
          handleSave={handSaveCallback}
        >
          <GenericGrid
            initialFetchParameters={defaultFetchParameter}
            visibleColumns={visibleColumns}
            editMode={editMode}
            fetchCallBack={fetchCallBack}
            detailCallBack={detailCallBack}
            deleteCallBack={deleteCallBack}
            activationCallBack={activationCallBack}
            deletionChanges={deletionChanges}
            activationChanges={activationChanges}
          />
        </GridWrapper>
      </div>
    </div>
  )
}
export default UserSummary
